import cx from 'classnames';
import { TrackedLink } from '../link';
import { PropsWithChildren } from 'react';

type TLinkSharingAdProps = {
  style?: any;
  className?: string;
  url: string;
  tag: string;
};

export type TLinkSharingSpecGuideAdProps = {
  class?: string;
  spec?: string;
  season?: string;
  className?: string;
  wrapperClasses?: string;
};

export type TLinkSharingSpecGuideAdVariantProps = PropsWithChildren<
  TLinkSharingSpecGuideAdProps & { guideUrl: string }
>;

export type TLinkSharingSpecSimAdProps = {
  class: string;
  spec: string;
  className?: string;
};

export type TLinkSharingSpecSimVariantProps = PropsWithChildren<TLinkSharingSpecSimAdProps & { guideUrl: string }>;

export const LinkSharingAd = (props: PropsWithChildren<TLinkSharingAdProps>) => {
  return (
    <TrackedLink
      href={props.url}
      as={props.tag}
      className={cx(props.className, 'slds-button rio-realm-link')}
      style={props.style}
      target="_blank"
    >
      {props.children}
    </TrackedLink>
  );
};
